export const TIME_AVAILABLE = 'TIME_AVAILABLE';

export const timeAvailable = () => ({
 
  type: TIME_AVAILABLE
  
})




// WEBPACK FOOTER //
// ./src/actions/timeSlots.js